import type { FormLocale } from '@jlg-website/shared';
import { CalendarDayItem } from './calendar-day-item';
import { firstWeekdayOfMonth } from '../shared/date-time';
import { weekdayHeadings } from './constants';
import type { CalendarDay } from './type';

type CalendarMonthProps = {
  month: string;
  days: CalendarDay[];
  selectedDate: string | null;
  locale: FormLocale;
  onSelect: (date: string) => void;
};

export function CalendarMonth({ month, days, selectedDate, locale, onSelect }: CalendarMonthProps) {
  const leadingBlanks = Array.from({ length: firstWeekdayOfMonth(month) }, (_, index) => index);
  const headings = weekdayHeadings[locale] ?? weekdayHeadings.en;

  return (
    <div className="overflow-hidden rounded-xl border border-brand-muted-light">
      <div className="grid grid-cols-7 bg-brand-primary">
        {headings.map((weekday) => (
          <span
            key={weekday}
            className="py-2 text-center text-[11px] font-semibold tracking-wide text-white"
          >
            {weekday}
          </span>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-1 p-2">
        {leadingBlanks.map((blank) => (
          <span key={`blank-${blank}`} aria-hidden="true" />
        ))}

        {days.map((day) => (
          <CalendarDayItem
            key={day.date}
            day={day}
            selected={day.date === selectedDate}
            locale={locale}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  );
}
